
import { Link } from "react-router-dom";
import { useAppTranslation } from "./TranslationContext";

export const Footer = () => {

  const { t } = useAppTranslation();

    return (
        <footer>
            <div className="container">

            <div className="section1">
                <Link className="logo" to="/">
                    <span>{t('logo')}</span>
                    <p>{t('logoSub')}</p>
                </Link>
            </div>

            <div className="section2">
                <div className="tels">
                    <div className="tel1">
                        <a className="tel" href={`tel:${t('tel')}`}>{t('tel')}</a>
                    </div>

                    <div className="tel2">
                        <a className="tel" href={`mailto:${t('mail')}`}>{t('mail')}</a>
                    </div>

                    <div className="location">
                        <p className="locate">{t('addressFooter')}</p>
                    </div>
                </div>
            </div>

            <div className="section3">
                <p className="legal">{t('legalFoo')}</p>
                <div className="information">
                    <p className="part">{t('legal1')} <span>{t('legal2')}</span> {t('legal3')}</p>
                </div>
            </div>

            <div className="footer">
                <p className="copy">&copy;{t('yearFoo')},</p>
                <p className="award">{t('infoFoo')}</p>
            </div>

            </div>
        </footer>
    );
}
